module.exports = __webpack_public_path__ + "img/side-icon-11.f93590b8.svg";